<script>
import { mapActions, mapGetters } from 'vuex';
import { WithBreakpointComponent } from './breakpoints';
export default {
    mixins: [WithBreakpointComponent],
    props: [
        'observerSections',
        'openModal',
        'subPage',
        'communityUrl'
    ],

    data() {
        return {
            selectedItem: false,
            mobileNav: false,
            activeView: false,
            activeFloorplan: false,
            observer: false,
            backToMicrosite: false,
            backListener: false,
            isFromQMI: false
        };
    },

    beforeMount() {
        if (this.subPage == 'floorplan_detail') {
            this.backToMicrosite = true;
            this.activeView = 'floorplan-detail';
            this.selectedItem = 'floorplans';
        } else {
            this.activeView = 'microsite';
        }
    },
    created() {
        const params = new URLSearchParams(window.location.search);
        this.isFromQMI = !!params.get('qmidetail');
    },
    mounted() {
        this.initListeners();
        const hash = document.location.hash;

        if (hash) {
            this.selectedItem = hash.replace(/#/g , "");
            this.scrollTo($(document.location.hash).offset().top);
        } else  {
            $(window).scrollTop(0);
            // this.selectedItem = 'overview';
        }

        if (this.activeView == 'microsite') {
            this.setObserver();
        }
    },
    beforeDestroy() {
        this.observer.disconnect();
        window.removeEventListener('popstate', this.backListener);
    },
    methods: {
        ...mapActions({
            put: 'app/put'
        }),
        initListeners() {
            this.backListener = window.addEventListener('popstate', ()=> {
                if (this.activeView === 'floorplan-detail') {
                    this.setActiveView('microsite');
                }
            });
        },
        setSelectedItem(item) {

            if (this.activeView === 'floorplan-detail') {
                this.setActiveView('microsite');
            }

            const elem = document.getElementById(item);
            this.selectedItem = item;
            if (elem) {
                this.scrollTo($(elem).offset().top);
            }
            // close nav on item select
            this.triggerDropdown();
        },
        triggerDropdown() {
            this.mobileNav = !this.mobileNav;
        },
        goTo(url, target) {
            window.open(url, (target || '_self'));
        },
        setActiveView(view, residence, images, hash) {
            this.activeView = view;

            // If we're switching to floorplan detail view
            if(this.activeView == 'floorplan-detail')  {
                this.$eventsBus.$emit('switch-to-detail');
                this.put({
                    key: 'floorplanDetail',
                    value: {
                        residence,
                        images
                    }
                });
                history.pushState({}, residence.name, residence.url);
                if(hash) {
                    const elem = document.getElementById(hash);
                    this.setSelectedItem(hash);
                    if (elem) {
                        this.scrollTo($(elem).offset().top);
                    }
                    document.location.hash = `#${hash}`;
                } else {
                    $(window).scrollTop(0);
                }
            } else {
                history.pushState({}, 'Kiper Homes',  this.communityUrl);
                this.$nextTick(()=> {
                    if(hash) {
                        const elem = document.getElementById(hash);
                        this.setSelectedItem(hash);
                        if (elem) {
                            this.scrollTo($(elem).offset().top);
                        }
                        document.location.hash = `#${hash}`;
                    }
                    this.setObserver();
                });
            }
        },
        scrollTo(y) {
            const headerHeight = (this.currentBreakpoint === 'phone')
                ? 80 // Mobile header height
                : (this.currentBreakpoint === 'tablet')
                    ? 100 // Tablet header height
                    : 126; // Greater than tablet header height
            $('html,body').animate({scrollTop: y - headerHeight}, 1000, 'swing');
        },
        setObserver() {
            var config = {
                threshold: 0.44
            };

            this.observer = new IntersectionObserver((entries, self)=> {
                entries.forEach((entry, ratio) => {

                    if (entry.isIntersecting && entry.intersectionRatio >= 0.44) {
                        intersectionHandler(entry);
                    }
                });
            }, config);

            this.observerSections.forEach(section => {
                const elem = document.querySelector(section);
                if (elem) {
                    this.observer.observe(elem);
                }
            });

            function intersectionHandler(entry) {
                var id = entry.target.id;
                var currentlyActive = document.querySelector('.community-nav__list-item.active');
                var shouldBeActive = document.querySelector('.community-nav__list-item[data-ref=' + id + ']');

                if (currentlyActive) {
                    currentlyActive.classList.remove('active');
                }
                if (shouldBeActive) {
                    if (currentlyActive) {
                        currentlyActive.classList.remove('active');
                    }
                    history.replaceState(null, null, `#${id}`);
                    shouldBeActive.classList.add('active');
                }
            }
        }
    }
};
</script>
